// Extra icons used by the new pages
import {
  Home, CheckSquare, Calendar, FileText, Folder, MessageCircle, MoreHorizontal,
  Plus, Search, X, Pin, Trash2, Eye, EyeOff, Lock, Link as LinkIcon, ChevronRight, ChevronLeft,
  Bold, Italic, Underline, List, ListOrdered, Quote, Strikethrough, Heading1, Heading2,
  Download, ArrowUpRight, Upload, FolderPlus, LogOut, Settings as SettingsIcon, Users,
  Bell, Filter, Send, Image as ImageIcon, Film, Music, File, FileSpreadsheet, Archive,
  Loader2, Check, AlertTriangle, ChevronDown, ArrowLeft, ArrowRight, MoreVertical, Sparkles, Clock,
  TrendingUp, Inbox, MessageSquare, Sun, Moon,
  Camera, Video, Palette, Layers, Repeat, UserPlus, Target, LayoutGrid, Briefcase,
  Mic, Music2, Zap, Flame, Star, Heart, Shield, Globe, Smile, BarChart3, Menu, Lightbulb, Mail,
  AlignLeft, AlignCenter, AlignRight, AlignJustify, Indent, Outdent,
  RotateCcw, RotateCw, Printer, Type, Eraser, Table, ListChecks,
  MessageSquarePlus, Highlighter, Pilcrow, Pencil, ExternalLink,
  GripVertical, CheckCircle, Scissors,
  PanelLeftClose, PanelLeftOpen, PanelRightClose, PanelRightOpen,
  BellOff, Share2 as Share, Trophy, RefreshCw,
} from 'lucide-react';

export {
  Home, CheckSquare, Calendar, FileText, Folder, MessageCircle, MoreHorizontal,
  Plus, Search, X, Pin, Trash2, Eye, EyeOff, Lock, LinkIcon, ChevronRight, ChevronLeft,
  Bold, Italic, Underline, List, ListOrdered, Quote, Strikethrough, Heading1, Heading2,
  Download, ArrowUpRight, Upload, FolderPlus, LogOut, SettingsIcon, Users,
  Bell, Filter, Send, ImageIcon, Film, Music, File, FileSpreadsheet, Archive,
  Loader2, Check, AlertTriangle, ChevronDown, ArrowLeft, ArrowRight, MoreVertical, Sparkles, Clock,
  TrendingUp, Inbox, MessageSquare, Sun, Moon,
  Camera, Video, Palette, Layers, Repeat, UserPlus, Target, LayoutGrid, Briefcase,
  Mic, Music2, Zap, Flame, Star, Heart, Shield, Globe, Smile, BarChart3, Menu, Lightbulb, Mail,
  AlignLeft, AlignCenter, AlignRight, AlignJustify, Indent, Outdent,
  RotateCcw, RotateCw, Printer, Type, Eraser, Table, ListChecks,
  MessageSquarePlus, Highlighter, Pilcrow, Pencil, ExternalLink,
  GripVertical, CheckCircle, Scissors,
  PanelLeftClose, PanelLeftOpen, PanelRightClose, PanelRightOpen,
  BellOff, Share, Trophy, RefreshCw,
};

// Project icon map
export const PROJECT_ICONS = {
  camera:    Camera,
  video:     Video,
  palette:   Palette,
  briefcase: Briefcase,
  layers:    Layers,
  mic:       Mic,
  music:     Music2,
  zap:       Zap,
  flame:     Flame,
  star:      Star,
};

export const ProjectIcon = ({ name = 'camera', size = 18, color = '#5BBEFC' }) => {
  const C = PROJECT_ICONS[name] || Camera;
  return <C size={size} color={color} strokeWidth={1.6} />;
};

export const FileKindIcon = ({ kind, size = 18, className = '' }) => {
  const map = { 'file-text': FileText, image: ImageIcon, film: Film, music: Music, sheet: FileSpreadsheet, archive: Archive, file: File };
  const C = map[kind] || File;
  return <C size={size} className={className} strokeWidth={1.5} />;
};
